function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var PanelCvHistoricComponentCtrl = /*#__PURE__*/function () {
  PanelCvHistoricComponentCtrl.$inject = ["$log", "AccesoDatos"];
  function PanelCvHistoricComponentCtrl($log, AccesoDatos) {
    _classCallCheck(this, PanelCvHistoricComponentCtrl);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "history", {
      add: {
        active: false,
        text: '',
        state: null
      },
      list: []
    });
    this.$log = $log;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelCvHistoricComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PanelCvHistoricComponentCtrl] onInit');
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(obj) {
      if (obj && obj.cvhist) {
        this.report = null;
        this.history.add.active = false;
        this.history.add.state = null;
        this.history.add.text = '';
        if (obj.cvhist.currentValue) this._leerCV();
      }
      if (obj.tipos && obj.tipos.currentValue) {
        this.$log.info('----> tipos!!!');
        this.statesStore = this.tipos.estadosStore();
      }
    }
  }, {
    key: "_leerCV",
    value: function _leerCV() {
      var _this = this;
      this.$loading = true;
      this.AccesoDatos.HistoricCurr_CLIENT.datosCvHistorico(this.cvhist.curr.idcvhist).then(function (reportResponse) {
        _this.report = reportResponse;
        _this.history.list = reportResponse.history.list;
        _this.$loading = false;
      });
    }
  }, {
    key: "_refreshcv",
    value: function _refreshcv() {
      this.report = null;
      this._leerCV();
    }
  }]);
}();
angular.module('candidato').component('panelCvHistoric', {
  bindings: {
    cvhist: '<',
    tipos: '<'
  },
  controller: PanelCvHistoricComponentCtrl,
  // templateUrl: "panel-cv-historic.component.html",
  template: require('./panel-cv-historic.component.html')
});